import { gql } from "@apollo/client";
import EmployerFields from "../fragments/employer-fragment";

export default gql`
  mutation deactivateEmployer($data: EmployerInput!) {
    deactivateEmployer(data: $data) {
      ...EmployerFields
    }
  }
  ${EmployerFields}
`;
